import React from "react";
import SpecialImage from "../assets/whychoose.png"; // Replace with your image
import "./Special.css";
import "../styles/main.css"; // Optional for custom styling

function Hero() {
  return (
    <section className="special-section container-fluid py-5">
      <div className="container">
        <div className="row align-items-center">

          <div className="col-12 col-md-6 text-center text-md-start order-1 order-md-1">
            <h2 className="special-title">Why Choose EZ MedServ?</h2>

            <div className="special-divider mx-md-0"></div>

            <p className="special-description">
                At EZ MedServ, we go beyond outsourcing we become a true partner in your success.
                With expertise across multiple industries, from banking and healthcare to retail 
                and technology, we understand the unique challenges businesses face. Our customer-centric
                approach ensures that every solution is designed with your clients in mind, while our scalable and flexible services grow alongside your business.
            </p>
              <a href="#contact" className="btn btn-special-mobile me-3">
                <i className="fas fa-envelope"></i> Contact Us
              </a>
          </div>

          <div className="col-12 col-md-6 text-center mb-4 mb-md-0 order-2 order-md-2">
            <img
              src={SpecialImage}
              alt="Why choose us?"
              className="special-img img-fluid"
            />
          </div>

        </div>
      </div>
    </section>
  );
}

export default Hero;